import React from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import ApiConnectorCard from "../ApiConnectorCard"
import verdiktLogo from "assets/images/logos/verdikt-logo-motto.png"

/**
 * Verdikt API card for the developer portal
 * Links to the Swagger documentation page
 */
const VerdiktApiCard = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const handleClick = () => {
    history.push("/developer/api")
  }

  return (
    <ApiConnectorCard
      serviceName={t("developer_portal:connectors.verdikt_api.name")}
      description={t("developer_portal:connectors.verdikt_api.description")}
      tag={t("developer_portal:connectors.verdikt_api.tag")}
      status="configure_now"
      statusLabel={t("developer_portal:status_labels.view_documentation")}
      onStatusClick={handleClick}
      logoSource={verdiktLogo}
      logoAlt="Verdikt"
      // fillIcon={true}
    />
  )
}

export default VerdiktApiCard
